import type {
  TextareaSlots as TextareaBaseSlots,
  TextareaBaseProps,
  TextareaBaseState,
} from '@fluentui/react-textarea';

/**
 * Textarea component slots
 */
export type TextareaSlots = TextareaBaseSlots;

/**
 * Textarea component props
 */
export type TextareaProps = TextareaBaseProps;

/**
 * Textarea component state
 */
export type TextareaState = TextareaBaseState & {
  root: {
    'data-disabled'?: string;
    'data-invalid'?: string;
    'data-resize'?: TextareaBaseState['resize'];
  };
};
